(() => {
  'use strict';
  function initLiquidBackground() {
    const canvas = document.getElementById('sg-native-canvas');
    const home = document.querySelector('.sg-home');
    if (!canvas || !home || typeof THREE === 'undefined') return;

    // Dynamic Effect Parameters
    const config = window.SetsugekkaRipple || {};
    const liquidStrength = config.enabled === false ? 0 : (typeof config.strength === 'number' ? config.strength : 0.16);
    const baseRadius = typeof config.radius === 'number' ? config.radius : 55;
    const rippleLifetime = 2000; // Each stroke fades from its creation, even while the pointer moves.
    const fogSpeed = Math.max(0, Math.min(2, Number(home.dataset.sgFogSpeed || 50) / 50));

    // A. Offscreen Canvas for Ripple Vector Simulation (Trail Map)
    const trailSize = 384;
    const trailCanvas = document.createElement('canvas');
    trailCanvas.width = trailSize;
    trailCanvas.height = trailSize;
    const trailCtx = trailCanvas.getContext('2d');
    // Scalar water-height field. The shader derives a smooth surface normal
    // from this map, so the original background colour remains untouched.
    trailCtx.fillStyle = 'rgb(0, 0, 0)';
    trailCtx.fillRect(0, 0, trailSize, trailSize);

    const trailTexture = new THREE.CanvasTexture(trailCanvas);
    trailTexture.flipY = false; // Keep 1:1 with 2D screen coordinate space
    trailTexture.minFilter = THREE.LinearFilter;
    trailTexture.magFilter = THREE.LinearFilter;
    const fogTexture = home.dataset.sgFogTexture
      ? new THREE.TextureLoader().load(home.dataset.sgFogTexture, (texture) => {
          texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
          texture.minFilter = texture.magFilter = THREE.LinearFilter;
        })
      : trailTexture;
    fogTexture.wrapS = fogTexture.wrapT = THREE.RepeatWrapping;

    // Mouse Tracking in normalized viewport coordinates
    const mouse = { x: 0, y: 0 };
    const smoothVelocity = { x: 0, y: 0 };
    let pointerSeen = false;
    const strokes = [];
    let currentStroke = null;
    const strokeInterval = 50;

    function strokeAt(now) {
      if (!currentStroke || now - currentStroke.created >= strokeInterval) {
        const layer = document.createElement('canvas');
        layer.width = trailSize;
        layer.height = trailSize;
        currentStroke = { created: now, layer, ctx: layer.getContext('2d') };
        strokes.push(currentStroke);
      }
      return currentStroke.ctx;
    }

    window.addEventListener('pointermove', (e) => {
      const nextX = e.clientX / window.innerWidth;
      const nextY = e.clientY / window.innerHeight;
      if (!pointerSeen) {
        mouse.x = nextX;
        mouse.y = nextY;
        pointerSeen = true;
        return;
      }
      const dx = nextX - mouse.x;
      const dy = nextY - mouse.y;
      const distance = Math.hypot(dx, dy);
      if (distance > 0.28) {
        mouse.x = nextX;
        mouse.y = nextY;
        return;
      }
      const rawVx = Math.max(-0.8, Math.min(0.8, dx * 12));
      const rawVy = Math.max(-0.8, Math.min(0.8, dy * 12));
      smoothVelocity.x += (rawVx - smoothVelocity.x) * 0.34;
      smoothVelocity.y += (rawVy - smoothVelocity.y) * 0.34;
      const vx = smoothVelocity.x;
      const vy = smoothVelocity.y;
      const stampCtx = strokeAt(performance.now());
      const steps = Math.min(18, Math.max(1, Math.ceil(distance * trailSize / (baseRadius * 0.38))));
      for (let step = 1; step <= steps; step++) {
        const t = step / steps;
        drawRipple(stampCtx, mouse.x + dx * t, mouse.y + dy * t, vx, vy);
      }
      mouse.x = nextX;
      mouse.y = nextY;
    });

    function drawRipple(stampCtx, x, y, vx, vy) {
      // 1:1 Coordinate match: x(0~1), y(0~1) where (0,0) is top-left
      const px = x * trailSize;
      const py = y * trailSize;
      const speed = Math.sqrt(vx * vx + vy * vy);
      const scale = trailSize / 256;
      const radius = Math.min(Math.max(speed * (baseRadius * 0.5) + (baseRadius * 0.42), 16), baseRadius * 1.4) * scale;
      const length = Math.max(speed, 0.001);
      const nx = vx / length;
      const ny = vy / length;
      const angle = Math.atan2(vy, vx);

      // Overlapping height lobes merge into one continuous marble-like wake.
      // Direction is expressed by the shape, not by coloured vector pixels.
      const stampHeight = (offsetX, offsetY, opacity, stretch, radiusScale = 1) => {
        stampCtx.save();
        stampCtx.translate(px + offsetX, py + offsetY);
        stampCtx.rotate(angle);
        stampCtx.scale(stretch, 1);
        const lobeRadius = radius * radiusScale;
        const grad = stampCtx.createRadialGradient(0, 0, 0, 0, 0, lobeRadius);
        grad.addColorStop(0, `rgba(255, 255, 255, ${opacity})`);
        grad.addColorStop(0.34, `rgba(255, 255, 255, ${opacity * 0.86})`);
        grad.addColorStop(0.72, `rgba(255, 255, 255, ${opacity * 0.28})`);
        grad.addColorStop(1, 'rgba(255, 255, 255, 0)');
        stampCtx.beginPath();
        stampCtx.arc(0, 0, lobeRadius, 0, Math.PI * 2);
        stampCtx.fillStyle = grad;
        stampCtx.fill();
        stampCtx.restore();
      };

      const side = radius * 0.18;
      stampHeight(0, 0, 0.22, 1.35 + speed * 0.95, 1.08);
      stampHeight(-ny * side, nx * side, 0.10, 1.12, 0.92);
      stampHeight(ny * side, -nx * side, 0.10, 1.12, 0.92);
    }

    // B. Three.js Scene, Camera, Renderer
    const scene = new THREE.Scene();
    const camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
    const renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true, antialias: true });
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    const heroVideo = home.querySelector('.sg-home__hero-media video');
    const heroImage = home.querySelector('.sg-home__hero-media img:not(.sg-home__placeholder)');
    const mainContent = document.getElementById('MainContent');
    const collectPanels = () => [
      ...home.querySelectorAll('.sg-home__blocks > .sg-home__panel'),
      ...Array.from(mainContent?.querySelectorAll(':scope > .shopify-section') || []).filter((wrapper) => wrapper !== home.closest('.shopify-section') &&
        (wrapper.querySelector('[data-sg-section-scene]') || wrapper.querySelector('.sg-home__panel')))
    ].sort((a, b) => a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1);
    let panelNodes = collectPanels();
    const scrollLink = home.querySelector('.sg-home__scroll');
    if (scrollLink && panelNodes[0]?.id) scrollLink.href = `#${panelNodes[0].id}`;
    const homeStyle = getComputedStyle(home);
    const colors = {
      ink: homeStyle.getPropertyValue('--sg-ink').trim() || '#151713',
      paper: homeStyle.getPropertyValue('--sg-paper').trim() || '#e7e4db'
    };
    const solidTexture = (color) => {
      const source = document.createElement('canvas');
      source.width = source.height = 2;
      const context = source.getContext('2d');
      context.fillStyle = color;
      context.fillRect(0, 0, 2, 2);
      const texture = new THREE.CanvasTexture(source);
      texture.minFilter = THREE.LinearFilter;
      return { texture, width: 2, height: 2 };
    };
    const ink = solidTexture(colors.ink);
    const paper = solidTexture(colors.paper);
    const backdrop = document.querySelector('.sg-native-backdrop');
    const scenes = [];
    const makeImageScene = (url, fallback, panel) => {
      if (!url) return fallback;
      const scene = { ...fallback };
      new THREE.TextureLoader().load(url, (texture) => {
        texture.minFilter = THREE.LinearFilter;
        scene.texture = texture;
        scene.width = texture.image.naturalWidth || texture.image.width || 2;
        scene.height = texture.image.naturalHeight || texture.image.height || 2;
        if (panel?.classList.contains('sg-home__about')) panel.classList.add('sg-native-panel-background');
      });
      return scene;
    };
    const heroFallback = home.dataset.sgHeroBgColor ? solidTexture(home.dataset.sgHeroBgColor) : ink;
    scenes.push(makeImageScene(home.dataset.sgHeroImage, heroFallback));
    const makeHero = () => {
      if (home.dataset.sgHeroImage) {
        home.classList.add('sg-native-hero-ready');
      } else if (heroVideo && heroVideo.readyState >= 2 && heroVideo.videoWidth) {
        const texture = new THREE.VideoTexture(heroVideo);
        texture.minFilter = THREE.LinearFilter;
        scenes[0] = { texture, width: heroVideo.videoWidth, height: heroVideo.videoHeight };
        home.classList.add('sg-native-hero-ready');
      } else if (heroImage && heroImage.complete && heroImage.naturalWidth) {
        scenes[0] = makeImageScene(heroImage.currentSrc || heroImage.src, heroFallback);
        home.classList.add('sg-native-hero-ready');
      }
    };
    makeHero();
    heroVideo?.addEventListener('loadeddata', makeHero, { once: true });
    heroImage?.addEventListener('load', makeHero, { once: true });
    function rebuildPanels() {
    panelNodes = collectPanels();
    scenes.length = 1;
    if (scrollLink && panelNodes[0]?.id) scrollLink.href = `#${panelNodes[0].id}`;
    for (const panel of panelNodes) {
      const source = panel.matches('.sg-home__panel') ? panel :
        (panel.querySelector('[data-sg-section-scene]') || panel.querySelector('.sg-home__panel'));
      const story = panel.matches('.sg-home__panel') ? panel : panel.querySelector('.sg-home__panel');
      const tone = story?.classList.contains('sg-home__tone--paper') || story?.classList.contains('sg-home__philosophy');
      const backdropElement = panel.querySelector('.section-background');
      const computed = backdropElement ? getComputedStyle(backdropElement).backgroundColor : getComputedStyle(panel).backgroundColor;
      const fallbackColor = source?.dataset.sgBgColor || (story ? (tone ? colors.paper : colors.ink) :
        (computed !== 'rgba(0, 0, 0, 0)' && computed !== 'transparent' ? computed : colors.paper));
      scenes.push(makeImageScene(source?.dataset.sgBgImage, solidTexture(fallbackColor), story));
      if (!story) panel.classList.add('sg-native-atelier-section');
    }
    }
    rebuildPanels();
    for (const eventName of ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder']) {
      document.addEventListener(eventName, () => requestAnimationFrame(rebuildPanels));
    }

    // D. Custom Liquid Shader with Perfect UV & Aspect-Ratio Cover
    const uniforms = {
      uTextureCurrent: { value: scenes[0].texture },
      uTextureNext: { value: (scenes[1] || scenes[0]).texture },
      uProgress: { value: 0.0 },
      uVerticalTransition: { value: 0.0 },
      uHeroWeight: { value: 1.0 },
      uFogTexture: { value: fogTexture },
      uFogColor: { value: new THREE.Color(home.dataset.sgFogColor || '#e7e4db') },
      uFogDensity: { value: home.dataset.sgHeroFog === 'false' ? 0 : Math.min(0.8, Math.max(0, Number(home.dataset.sgFogDensity || 56) / 100)) },
      uTime: { value: 0.0 },
      uStrength: { value: liquidStrength },
      uDisplacement: { value: trailTexture },
      uResolution: { value: new THREE.Vector2(window.innerWidth, window.innerHeight) },
      uImageResolution: { value: new THREE.Vector2(2, 2) },
      uNextResolution: { value: new THREE.Vector2(2, 2) },
      uCurrentScroll: { value: 0.0 },
      uNextScroll: { value: 0.0 }
    };

    const material = new THREE.ShaderMaterial({
      uniforms: uniforms,
      vertexShader: `
        varying vec2 vUv;
        void main() {
          vUv = uv;
          gl_Position = vec4(position.xy, 0.0, 1.0);
        }
      `,
      fragmentShader: `
        uniform sampler2D uTextureCurrent;
        uniform sampler2D uTextureNext;
        uniform float uProgress;
        uniform float uVerticalTransition;
        uniform float uHeroWeight;
        uniform sampler2D uFogTexture;
        uniform vec3 uFogColor;
        uniform float uFogDensity;
        uniform float uTime;
        uniform float uStrength;
        uniform sampler2D uDisplacement;
        uniform vec2 uResolution;
        uniform vec2 uImageResolution;
        uniform vec2 uNextResolution;
        uniform float uCurrentScroll;
        uniform float uNextScroll;
        varying vec2 vUv;

        // Aspect-ratio cover mapping function
        vec2 getCoverUv(vec2 uv, vec2 screenRes, vec2 imgRes) {
          float sRatio = screenRes.x / screenRes.y;
          float iRatio = imgRes.x / imgRes.y;
          vec2 res = uv;
          if (sRatio > iRatio) {
            float scale = iRatio / sRatio;
            // Pin portrait/tall images to their top edge instead of center-cropping.
            res.y = uv.y * scale + (1.0 - scale);
          } else {
            float scale = sRatio / iRatio;
            res.x = (uv.x - 0.5) * scale + 0.5;
          }
          return res;
        }

        float getVerticalTravel(vec2 screenRes, vec2 imgRes) {
          float sRatio = screenRes.x / screenRes.y;
          float iRatio = imgRes.x / imgRes.y;
          float coverScale = sRatio > iRatio ? iRatio / sRatio : 1.0;
          // The image is additionally enlarged to 80% UV below. This is the
          // exact remaining distance between its top-aligned and bottom-aligned states.
          return max(0.0, 1.0 - coverScale * 0.8);
        }

        void main() {
          // Sample displacement: vUv has (0,0) at bottom-left, while trailCanvas has (0,0) at top-left
          vec2 trailUv = vec2(vUv.x, 1.0 - vUv.y);
          vec2 texel = 1.0 / vec2(384.0);
          // Build a broad, continuous water-surface normal from the scalar
          // height map. Two sampling radii remove pixel noise and add a soft
          // secondary bend similar to thick liquid or marble.
          float leftNear = texture2D(uDisplacement, trailUv - vec2(texel.x * 2.5, 0.0)).r;
          float rightNear = texture2D(uDisplacement, trailUv + vec2(texel.x * 2.5, 0.0)).r;
          float topNear = texture2D(uDisplacement, trailUv - vec2(0.0, texel.y * 2.5)).r;
          float bottomNear = texture2D(uDisplacement, trailUv + vec2(0.0, texel.y * 2.5)).r;
          float leftWide = texture2D(uDisplacement, trailUv - vec2(texel.x * 7.0, 0.0)).r;
          float rightWide = texture2D(uDisplacement, trailUv + vec2(texel.x * 7.0, 0.0)).r;
          float topWide = texture2D(uDisplacement, trailUv - vec2(0.0, texel.y * 7.0)).r;
          float bottomWide = texture2D(uDisplacement, trailUv + vec2(0.0, texel.y * 7.0)).r;
          vec2 surfaceNormal = vec2(
            (rightNear - leftNear) * 0.72 + (rightWide - leftWide) * 0.28,
            (bottomNear - topNear) * 0.72 + (bottomWide - topWide) * 0.28
          );
          vec2 distortion = vec2(surfaceNormal.x, -surfaceNormal.y) * uStrength * 1.65;

          // Cover UV with distortion
          vec2 currentScreenUv = mix(vUv, vec2(vUv.x, vUv.y - uProgress), uVerticalTransition);
          vec2 nextScreenUv = mix(vUv, vec2(vUv.x, vUv.y + (1.0 - uProgress)), uVerticalTransition);
          vec2 baseUv = getCoverUv(currentScreenUv, uResolution, uImageResolution);
          baseUv.x = (baseUv.x - 0.5) * 0.8 + 0.5;
          baseUv.y = 1.0 - (1.0 - baseUv.y) * 0.8 - uCurrentScroll * getVerticalTravel(uResolution, uImageResolution);
          vec2 distortedUv = baseUv - distortion;

          vec4 col1 = texture2D(uTextureCurrent, distortedUv);
          col1.rgb *= mix(1.0, mix(0.55, 0.83, vUv.x), uHeroWeight);
          vec2 nextUv = getCoverUv(nextScreenUv, uResolution, uNextResolution);
          nextUv.x = (nextUv.x - 0.5) * 0.8 + 0.5;
          nextUv.y = 1.0 - (1.0 - nextUv.y) * 0.8 - uNextScroll * getVerticalTravel(uResolution, uNextResolution);
          nextUv -= distortion;
          vec4 col2 = texture2D(uTextureNext, nextUv);

          vec4 finalCol = mix(col1, col2, uProgress);
          if (uVerticalTransition > 0.5) {
            // The hero's lower edge travels upward and overlaps the incoming
            // section's upper edge. The broad feather is the crossfade zone.
            if (uProgress <= 0.001) {
              finalCol = col1;
            } else if (uProgress >= 0.999) {
              finalCol = col2;
            } else {
              float feather = 0.12;
              float nextWeight = 1.0 - smoothstep(uProgress - feather, uProgress + feather, vUv.y);
              finalCol = mix(col1, col2, nextWeight);
            }
          }

          // Full-viewport mist shares the same canvas as the crossfade, so its
          // lower edge cannot expose a section boundary while scrolling.
          float heroMist = uHeroWeight * (1.0 - smoothstep(0.48, 1.0, uProgress));
          if (uFogDensity > 0.0 && heroMist > 0.0) {
            vec2 driftNear = vec2(uTime * 0.012, 0.0);
            vec2 driftFar = vec2(uTime * 0.007 + 0.43, 0.31);
            float nearFog = texture2D(uFogTexture, vUv * vec2(1.08, 0.90) + driftNear).a;
            float farFog = texture2D(uFogTexture, vUv * vec2(1.31, 1.02) + driftFar).a;
            float lower = mix(0.46, 1.0, 1.0 - smoothstep(0.0, 1.0, vUv.y));
            float mist = heroMist * uFogDensity * lower * (nearFog * 0.72 + farFog * 0.34);
            finalCol.rgb = mix(finalCol.rgb, uFogColor, clamp(mist, 0.0, 0.28));
          }

          gl_FragColor = finalCol;
        }
      `,
      transparent: true
    });

    const geometry = new THREE.PlaneGeometry(2, 2);
    const mesh = new THREE.Mesh(geometry, material);
    scene.add(mesh);

    // Resize Handler
    window.addEventListener('resize', () => {
      renderer.setSize(window.innerWidth, window.innerHeight);
      uniforms.uResolution.value.set(window.innerWidth, window.innerHeight);
    });

    const clamp = (value) => Math.max(0, Math.min(1, value));
    let lastScene = -1;
    function updateScroll() {
      const threshold = window.innerHeight;
      let sceneIndex = 0;
      let progress = 0;
      for (let i = 0; i < panelNodes.length; i++) {
        const offset = panelNodes[i].getBoundingClientRect().top;
        if (offset > threshold) break;
        sceneIndex = i;
        const distance = i === 0
          ? Math.max(window.innerHeight * (Number(home.dataset.sgHeroTransition || 80) / 100), 1)
          : window.innerHeight * 0.5;
        progress = clamp((threshold - offset) / distance);
      }
      const destination = panelNodes[sceneIndex];
      const sceneSource = destination?.matches('.sg-home__panel') ? destination :
        (destination?.querySelector('[data-sg-section-scene]') || destination?.querySelector('.sg-home__panel'));
      if (sceneSource?.dataset.sgBgEffect === 'false') progress = progress >= 0.5 ? 1 : 0;
      const current = scenes[sceneIndex] || ink;
      const next = scenes[sceneIndex + 1] || current;
      uniforms.uTextureCurrent.value = current.texture;
      uniforms.uTextureNext.value = next.texture;
      uniforms.uImageResolution.value.set(current.width, current.height);
      uniforms.uNextResolution.value.set(next.width, next.height);
      uniforms.uProgress.value = progress;
      uniforms.uVerticalTransition.value = sceneIndex === 0 ? 1 : 0;
      uniforms.uHeroWeight.value = sceneIndex === 0 ? 1 : 0;
      const sceneMotion = (element) => {
        if (!element) return 0;
        const rect = element.getBoundingClientRect();
        // A scene enters at its image top, then reveals lower parts progressively.
        return clamp((window.innerHeight - rect.top) / (window.innerHeight + rect.height));
      };
      const heroElement = home.querySelector('.sg-home__hero');
      const heroRect = heroElement?.getBoundingClientRect();
      const heroHoldDistance = Math.max(window.innerHeight * (Number(home.dataset.sgHeroHold || 60) / 100), 1);
      const heroMotion = heroRect ? clamp(-heroRect.top / heroHoldDistance) : 0;
      // The hero reaches its true image bottom before the first crossfade;
      // every incoming section begins from its true image top.
      uniforms.uCurrentScroll.value = sceneIndex === 0 ? heroMotion : sceneMotion(panelNodes[sceneIndex - 1]);
      uniforms.uNextScroll.value = sceneMotion(panelNodes[sceneIndex]);
      if (sceneIndex !== lastScene) {
        lastScene = sceneIndex;
        canvas.dataset.activeBackground = sceneIndex === 0 ? 'hero' : String(sceneIndex);
      }
    }
    function animate(now = performance.now()) {
      requestAnimationFrame(animate);
      uniforms.uTime.value = (now / 1000) * fogSpeed;
      updateScroll();
      while (strokes.length && now - strokes[0].created >= rippleLifetime) {
        strokes.shift();
      }
      uniforms.uStrength.value = strokes.length ? liquidStrength : 0;
      if (strokes.length) {
        trailCtx.globalAlpha = 1;
        trailCtx.fillStyle = 'rgb(0, 0, 0)';
        trailCtx.fillRect(0, 0, trailSize, trailSize);
        trailCtx.filter = 'blur(2.2px)';
        for (const stroke of strokes) {
          const remaining = Math.max(0, 1 - (now - stroke.created) / rippleLifetime);
          // Each stroke softens continuously over its own two-second lifetime.
          trailCtx.globalAlpha = remaining * remaining * (3 - 2 * remaining);
          trailCtx.drawImage(stroke.layer, 0, 0);
        }
        trailCtx.filter = 'none';
        trailCtx.globalAlpha = 1;
        trailTexture.needsUpdate = true;
      }
      renderer.render(scene, camera);
    }
    backdrop.classList.add('sg-native-active');
    animate();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLiquidBackground, { once: true });
  else initLiquidBackground();
})();
